/**
 * Seed 260 weekly challenges into the database.
 * Run once from admin/settings or a script.
 */
import { supabase } from './supabase';
import { CHALLENGES } from './challengeData';
import { createLogger } from './logger';

const log = createLogger('SEED_CHALLENGES');

export async function seedChallenges(): Promise<{ inserted: number; error: string | null }> {
  try {
    // Check if challenges already exist
    const { count } = await supabase
      .from('weekly_challenges')
      .select('id', { count: 'exact', head: true });

    if (count && count >= 260) {
      return { inserted: 0, error: 'Challenges already seeded.' };
    }

    // Batch insert in chunks of 50
    let inserted = 0;
    for (let i = 0; i < CHALLENGES.length; i += 50) {
      const batch = CHALLENGES.slice(i, i + 50).map(c => ({
        week_number: c.week_number,
        title: c.title,
        description: c.description,
        category: c.category,
        target_lift: c.target_lift,
        target_metric: c.target_metric,
        target_value: null,
        scoring_method: c.scoring_method,
      }));

      const { error } = await supabase
        .from('weekly_challenges')
        .upsert(batch, { onConflict: 'week_number', ignoreDuplicates: true });

      if (error) {
        log.error('Seed batch failed:', error);
        return { inserted, error: error.message };
      }
      inserted += batch.length;
    }

    log.info(`Seeded ${inserted} challenges`);
    return { inserted, error: null };
  } catch (err: any) {
    return { inserted: 0, error: err.message };
  }
}
